/**
 * Configuración centralizada de URLs del backend
 * Detecta automáticamente el entorno (producción vs desarrollo)
 * IMPORTANTE: La detección por hostname tiene PRIORIDAD sobre variables de entorno
 */

const getBackendUrl = () => {
  // Detectar automáticamente basado en el hostname PRIMERO
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Producción: damyxia.com - SIEMPRE usar el backend de producción
    if (hostname === 'damyxia.com' || hostname === 'www.damyxia.com') {
      return 'https://damyxia.com';
    }
    
    // Preview de Emergent - usar la URL del preview
    if (hostname.includes('preview.emergentagent.com') || hostname.includes('emergent.host')) {
      return `https://${hostname}`;
    }
    
    // Localhost para desarrollo
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    }
    
    // Fallback: usar el mismo origen
    return window.location.origin;
  }
  
  // Server-side rendering fallback
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

// Export para compatibilidad con código existente
export { getBackendUrl };

export default {
  BACKEND_URL,
  API_URL,
  getBackendUrl
};
